
<div mat-dialog-title>Security Results<button class="close" mat-button title="Cancel" (click)="close()"><i class="material-icons clear" >clear</i></button></div>
<mat-dialog-content>
  <div class="block bold">{{totalSecutitiesCount}} Symbol(s)/CUSIP(s)@if (inValidSymbolCnt > 0) {
    <span> ({{inValidSymbolCnt}} invalid symbols.)</span>
  }</div>
  @if (!isValidToContinue) {
    <mat-card class="error block">
      <mat-card-title class="error">A security type must be specified for each custom security being added (highlighted below).</mat-card-title>
    </mat-card>
  }
  @if (data.isCashType) {
    <mat-card >
      <mat-card-title >Account sweeps which you entered are not listed here, because they cannot be added to iRebal.</mat-card-title>
    </mat-card>
  }

  @if (gridOptions_inventoried && data.Inventoried.data.length > 0) {
    <div>
      <!--<div *ngIf="!data.isCreateSecurites" class="bold">{{data.Inventoried?.data.length}} in iRebal's security master (these can't be added again)</div>-->
      <div class="bold block">{{data.Inventoried?.data.length}} already in iRebal's Security Inventory</div>
      @if ((data.unRecognized?.count != 0 || data.NonInventoried?.count != 0) && data.Inventoried?.count != 0) {
        <div>
          <irb-inventory-grid
            [style.width] = "'100%'"
            [style.height] = "'130px'"
            [showSideBar] = "false"
            [gridOptions] = "gridOptions_inventoried"
            [frameworkComponents] = 'frameworkComponents_inventoried'
            [rowData] = 'data.Inventoried?.data'
          (gridReady) = "onInventoriedGridReady($event)"></irb-inventory-grid>
        </div>
      }
      @if (data.unRecognized?.count == 0 && data.NonInventoried?.count == 0 && data.Inventoried?.count != 0) {
        <div>
          <irb-inventory-grid
            [style.width] = "'100%'"
            [style.height] = "'220px'"
            [showSideBar] = "false"
            [gridOptions] = "gridOptions_inventoried"
            [frameworkComponents] = 'frameworkComponents_inventoried'
            [rowData] = 'data.Inventoried?.data'
          (gridReady) = "onInventoriedGridReady($event)"></irb-inventory-grid>
        </div>
      }
    </div>
  }

  @if (gridOptions_noninventoried && data.NonInventoried?.data.length > 0) {
    <div>
      <!--<div *ngIf="!data.isCreateSecurites" class="bold">{{data.NonInventoried?.data.length}} Not in iRebal's security master (select those to add to iRebal)</div>-->
      <div class="bold block">{{data.NonInventoried?.data.length}} new securities can be added</div>
      <div>
        <irb-inventory-grid
          [style.width] = "'100%'"
          [style.height] = "'130px'"
          [showSideBar] = "false"
          [gridOptions] = "gridOptions_noninventoried"
          [frameworkComponents] = 'frameworkComponents_noninventoried'
          [rowData] = 'data.NonInventoried?.data'
        (gridReady) = "onNoninventoriedGridReady($event)"></irb-inventory-grid>
      </div>
    </div>
  }

  @if (gridOptions_unrecognized && data.unRecognized?.data.length > 0) {
    <div>
      <!--<div *ngIf="!data.isCreateSecurites" class="bold">{{data.unRecognized?.data.length}} Unrecognized securities (add these as a custom security &ndash; provide description and type)</div>-->
      <div class="bold block">{{data.unRecognized?.data.length}} custom securities can be added</div>
      <div>
        <irb-inventory-grid
          [style.width] = "'100%'"
          [style.height] = "'130px'"
          [showSideBar] = "false"
          [gridOptions] = "gridOptions_unrecognized"
          [frameworkComponents] = 'frameworkComponents_unrecognized'
          [rowData] = 'data.unRecognized?.data'
        (gridReady) = "onUnRecognizedGridReady($event)"></irb-inventory-grid>
      </div>
    </div>
  }

</mat-dialog-content>
@if (data.unRecognized?.count != 0 || data.NonInventoried?.count != 0) {
  <mat-dialog-actions>
    <button id="closeButton" (click)="close()" class="btn-medium-secondary">Cancel</button>
    <button id="continueButton" (click)="completeImport()" [disabled]="totalSelectCount === 0" class="btn-medium-primary">Finish</button>
  </mat-dialog-actions>
}
@if ( data.unRecognized?.count == 0 && data.NonInventoried?.count == 0 && data.Inventoried?.count != 0) {
  <mat-dialog-actions>
    <button id="closeButton2" (click)="close()" class="btn-medium-secondary">Close</button>
  </mat-dialog-actions>
}
